import {Component} from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer">
			<div class="logo-text">
				<!--
				<img src="../../assets/layout/images/logo-clean.png" alt="mirage-layout" />
					-->
				<div class="text">
					<h1>Mi Nutriologo</h1>
					<span>Cuidamos tu salud, para que tu cuides a los tuyos</span>
				</div>
			</div>
			<div class="icons" *ngIf="false">
				<div class="icon icon-hastag">
					<i class="pi pi-home"></i>
				</div>
				<div class="icon icon-twitter">
					<i class="pi pi-globe"></i>
				</div>
				<div class="icon icon-prime">
					<i class="pi pi-bookmark"></i>
				</div>
			</div>
        </div>
    `
})
export class AppFooterComponent {

}
